// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddImageDialog_wrapper__2Q23f","btn":"AddImageDialog_btn__2A-vb"};